import React, { useState, useContext } from 'react';
import { ApiService } from '../Axios/ApiService';

const useCustomQty = (sku, productId) => {
    const [customPrices, setCustomPrices] = useState(false);
    const [customPricesLoading, setCustomPricesLoading] = useState(false);
    const [customPricesError, setCustomPricesError] = useState(false);
    const [customMinMax, setCustomMinMax] = useState(false);
    // const [submittingQty, setSubmittingQty] = useState({
    //     loading: false,
    //     error: false,
    // });

    const onCustomQtyPrice = async (variationId, quantity) => {
        const formData = {
            sku,
            product_id: productId,
            qty: quantity,
            variation_id: variationId,
        };
        setCustomPrices(false);
        setCustomPricesError(false);
        setCustomPricesLoading(true);
        try {
            const res = await ApiService.post('/get-single-price', formData);
            setCustomPrices(res.data);
            setCustomMinMax(res.data);
            setCustomPricesLoading(false);
        } catch (e) {
            setCustomPricesError(e);
            setCustomPricesLoading(false);

            console.error(e);
            throw e;
        }
    };

    return {
        onCustomQtyPrice,
        customPrices,
        customPricesLoading,
        customPricesError,
        customMinMax,
        setCustomPrices,
    };
};

export default useCustomQty;
